
export const PERMISSION_FEATURES = {
  INDIVIDUAL_TIME_REPORT: "Individual Time Report",
  BUDGET: "Budget",
  REQUEST: "Request",
  WORKFLOW: "Workflow",
  ADMIN: "Admin",
  OVERVIEW: "Overview",
} as const;

export const PERMISSION_ACTIONS = {
  CAN_VIEW_OTHERS_REPORT: "CanViewOthersReport",
  EDIT: "Edit",
  VIEW: "View",
  ASSIGN_REQUEST: "AssignRequest",
  ACTIVATE_WORKFLOW_TEMPLATE: "ActivateWorkflowTemplate",
  UPDATE_WORKFLOW_TASK_STATUS: "UpdateWorkflowTaskStatus",
  EDIT_ENGAGEMENT_DETAILS: "EditEngagementDetails",
} as const;

export type PermissionFeature =
  (typeof PERMISSION_FEATURES)[keyof typeof PERMISSION_FEATURES];

export type PermissionActionName =
  (typeof PERMISSION_ACTIONS)[keyof typeof PERMISSION_ACTIONS];